import React from 'react';
import { map, isArray } from 'lodash/fp';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Tag } from 'rsuite';

const SearchItem = styled.div`
  font-size: 14px;
  vertical-align: top;
  display: inline-block;
  .rs-tag + .rs-tag {
    margin-left: 1px;
  }
`;
const QueryLabel = styled.div`
  color: #575757;
  margin-bottom: 10px;
`;

const CustomTag = styled(Tag)`
  margin-bottom: 1px;
  margin-left: 1px;
`;

function SearchDetails({ data, itemWidth }) {
  return map(
    ({ label, value }) => (
      <SearchItem key={label} style={{ width: itemWidth }}>
        <QueryLabel>{label}:</QueryLabel>
        {isArray(value) ? (
          map(
            each => (
              <CustomTag color="blue" key={each}>
                {each}
              </CustomTag>
            ),
            value
          )
        ) : (
          <CustomTag color="blue">{value}</CustomTag>
        )}
      </SearchItem>
    ),
    data
  );
}

SearchDetails.propTypes = {
  itemWidth: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

SearchDetails.defaultProps = {
  itemWidth: '25%'
};

export default SearchDetails;
